var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FBE2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 8.0625C10.125 7.51549 10.3225 6.99089 10.6742 6.60409C11.0258 6.2173 11.5027 6 12 6C12.4973 6 12.9742 6.2173 13.3258 6.60409C13.6775 6.99089 13.875 7.51549 13.875 8.0625M10.125 8.0625H13.875M10.125 8.0625H8.25M13.875 8.0625H15.75M8.25 8.0625H7M8.25 8.0625V15.625C8.25 15.9897 8.3817 16.3394 8.61612 16.5973C8.85054 16.8551 9.16848 17 9.5 17H14.5C14.8315 17 15.1495 16.8551 15.3839 16.5973C15.6183 16.3394 15.75 15.9897 15.75 15.625V8.0625M15.75 8.0625H17",
    stroke: "#DA0B0B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventDel);
export default __webpack_public_path__ + "static/media/eventDel.cf313489c1f7b4b3d5ce6836d0c688d4.svg";
export { ForwardRef as ReactComponent };